// shared
import handleCartLinePercentDiscountTracking from 'shared/experiments/browser/cartLinePercentDiscount/eventsTracking'
import crosssellTracking from 'views/assets/scripts/crosssellTracking'
import { createFCWidgetForLogin } from 'views/assets/scripts/friendlyCaptcha'
import loadingScript from 'views/assets/scripts/isFormSubmitting'
import mountSellerModalForCrossSell from 'views/assets/scripts/mountSellerModalForCrossSell'
import nowModal from 'views/assets/scripts/nowModal'
import registerSliderStretcher from 'views/assets/scripts/registerSliderStretcher'
import runScripts from 'views/assets/scripts/runScripts'
import { initSlider as slider } from 'views/assets/scripts/slider'
import handleCartTracking from 'views/components/organisms/Cart/eventsTracking'
import initClientScriptsXsellSellerModal from 'views/components/organisms/XsellSellerModal/initClientScripts'
import mountContactShopApothekeModalContainer from 'views/containers/browser/ContactShopApothekeModalContainer/mountContactShopApothekeModalContainer'
import mountNowFaqModalContainer from 'views/containers/browser/NowFaqModalContainer/mountNowFaqModalContainer'
import mountNowShippingModalCartContainer from 'views/containers/browser/NowShippingModalCartContainer/mountNowShippingModalContainer'
import mountRxByPrincipleModalContainer from 'views/containers/browser/RxByPrincipleModalContainer/mountRxByPrincipleModalContainer'
import mountVolumePricingModalContainer from 'views/containers/browser/VolumePricingModalContainer/mountVolumePricingModalContainer'
import mountCart from 'views/containers/spa/Cart/mountCart'

import cartSessionStorageHandler from './cartSessionStorageHandler'

const animateCheckoutButton = loadingScript({
  formSelector: undefined,
  buttonId: 'ToCheckout',
  transitionDurationInSec: 1,
})

const animateCheckoutButtonTop = loadingScript(
  {
    formSelector: undefined,
    buttonId: 'ToCheckoutTop',
    transitionDurationInSec: 1,
    preserveWidth: true,
  },
  {
    color: '#005091',
  }
)

runScripts(
  mountCart,
  nowModal,
  slider,
  animateCheckoutButton,
  animateCheckoutButtonTop,
  mountSellerModalForCrossSell,
  mountNowShippingModalCartContainer,
  crosssellTracking,
  mountContactShopApothekeModalContainer,
  mountNowFaqModalContainer,
  cartSessionStorageHandler,
  registerSliderStretcher,
  createFCWidgetForLogin,
  handleCartTracking,
  initClientScriptsXsellSellerModal,
  mountRxByPrincipleModalContainer,
  handleCartLinePercentDiscountTracking,
  mountVolumePricingModalContainer
)
